import axiosConfig from './axiosConfig';

const apiCWCharge = {
   list: (filter) => axiosConfig.requests.get(`/CWCharges?PageNumber=${filter.pageNumber}&PageSize=${filter.pageSize}`),
};

export default { apiCWCharge };
